<div
  id="content"
  class="container mx-auto px-base pt-base">
  <div>
    <button (click)="login()">Iniciar Sesión</button>
    <button (click)="logout()">Cerrar Sesión</button>
    <button (click)="showTokens()">Ver Access Token</button>
  </div>
</div>
